module.exports = __webpack_public_path__ + "static/media/american-football-2.14fdcadd.svg";